export default __webpack_public_path__ + "static/media/5.8e4369b6.png";